/**
 * Der Einbindungs-Code fuer das oeffentliche Anfrageformular (Issue KAN-233).
 *
 * Bewusst eine reine Funktion neben der Komponente: Der Schnipsel landet per Kopieren
 * ungeprueft auf einer fremden Website — ein Fehler darin faellt niemandem hier auf,
 * sondern erst dem Kunden. Deshalb ist er einzeln testbar gehalten.
 */

/** Oeffentliche Route des Anfrageformulars (siehe Routes.tsx). */
export const PATIENT_REQUEST_FORM_PATH = "/pflegeplatz-anfragen";

/**
 * Dasselbe Einbettungs-Skript wie beim Karriereportal: Es hoert auf die Hoehenmeldung
 * der eingebetteten Seite und zieht den Rahmen mit.
 */
export const EMBED_SCRIPT_URL =
  "https://kandidat-io-integrations.s3.eu-central-1.amazonaws.com/scripts/kandidat-external-embed-script.js";

/**
 * Die id, die das Einbettungs-Skript in der Hand hat: Es greift fest auf
 * getElementById("karriereportal-iframe") zu. Eine sprechendere id waere schoener,
 * wuerde aber die automatische Hoehe stillschweigend abschalten — bis das Skript
 * selbst nachzieht, bleibt diese id Pflicht.
 */
export const EMBED_IFRAME_ID = "karriereportal-iframe";

/**
 * Hoehe, mit der der Rahmen startet, bevor die erste Hoehenmeldung ankommt. Ohne sie
 * stuende das Formular auf der Kundenseite kurz als Strich.
 */
const MIN_HEIGHT_PX = 760;

/** Fuehrt den Ursprung auf eine Form ohne Schluss-Schraegstrich zurueck. */
const normalizeOrigin = (origin: string): string => origin.replace(/\/+$/, "");

/**
 * Die oeffentliche Adresse des Anfrageformulars dieses Betriebs — absolut, weil sie auf
 * der Domain des Kunden steht und dort nichts relativ aufloesen kann.
 */
export const buildPatientRequestFormUrl = (organizationId: string, origin: string): string => {
  // Ohne Kennung zeigt die Adresse auf /pflegeplatz-anfragen/ ohne Betrieb. Die Route
  // trifft das nicht; der Besucher der Kundenwebsite landet auf einer Fehlerseite, und
  // zwar erst dort, wo es niemand von uns mehr bemerkt. Deshalb hier laut scheitern.
  if (!organizationId?.trim()) {
    throw new Error("Einbindungs-Code ohne Kennung des Betriebs angefordert");
  }

  return `${normalizeOrigin(origin)}${PATIENT_REQUEST_FORM_PATH}/${organizationId.trim()}`;
};

/**
 * Der fertige Schnipsel zum Einfuegen in die Kundenwebsite. Enthaelt alles, was es
 * braucht: die Kennung des Betriebs in der Adresse und das Einbettungs-Skript.
 */
export const buildPatientRequestEmbedSnippet = (organizationId: string, origin: string): string =>
  `<iframe frameborder="0" id="${EMBED_IFRAME_ID}" src="${buildPatientRequestFormUrl(
    organizationId,
    origin
  )}" width="100%" style="border: none; overflow: hidden; min-height: ${MIN_HEIGHT_PX}px;"></iframe>
<script src="${EMBED_SCRIPT_URL}"></script>`;
